import { Box, Button, Flex, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { CenteredContent } from "../CenteredContent";
import { Href } from "../Href";

export function ContactBand() {
  return (
    <Box bgColor="brandPrimary.500">
      <Box
        position="relative"
        padding={{ base: "2.8rem .625rem", md: "4.375rem 2rem" }}
        bgImage={`url(${generateFrontPath({
          id: "@front.internal-assets",
          parameters: { filePath: "pattern-with-gradient.png" },
          includeBasePath: true,
        })})`}
        bgSize="auto"
        bgPosition={{ base: "bottom", md: "center" }}
        bgRepeat="no-repeat"
        overflow="hidden">
        <CenteredContent>
          <SimpleGrid
            templateColumns={{ base: "1", md: "60% 40%" }}
            spacing="2rem">
            <Stack spacing="1rem">
              <Text variant="h1" color="white">
                <FormattedMessage defaultMessage="Vous êtes victime d'un sinistre ?" />
              </Text>

              <Text variant="h4" color="white">
                <FormattedMessage defaultMessage="Faites confiance au savoir-faire du cabinet Valentin Expertises pour vous accompagner dans la défense indépendante de vos intérêts" />
              </Text>
            </Stack>

            <Flex
              height="full"
              width="full"
              justifyContent={{ base: "flex-start", md: "center" }}
              alignItems="center">
              <Href href={generateFrontPath({ id: "@front.contact" })}>
                <Button
                  colorScheme="gray"
                  h="52px"
                  variant="outline"
                  _hover={{ color: "brandPrimary.700", bg: "white" }}
                  color="white">
                  <FormattedMessage defaultMessage="Obtenir un rendez-vous" />
                </Button>
              </Href>
            </Flex>
          </SimpleGrid>
        </CenteredContent>
      </Box>
    </Box>
  );
}
